import styled from '@emotion/styled';
import { borderRadius } from '@shared/constants/Styles';
import { MixinFocusVisible } from '../structure/DefaultStyles';

/**
 * Plain pill-style tab button (no icon/status states). For the richer tab with
 * active icon, underline, and status alerts, use `TabButton` (TabButton.tsx).
 */
export const SimpleTab = styled.button<{ isActive: boolean }>`
    padding: 0.5rem 1rem;
    border: none;
    background: ${(props) => (props.isActive ? props.theme.color.accent : props.theme.color.cardHover)};
    color: ${(props) => (props.isActive ? props.theme.color.background : props.theme.button.secondary.text)};
    cursor: pointer;
    border-radius: ${borderRadius.pill};
    transition: all 0.2s ease;
    &:hover {
        background: ${(props) => props.theme.button.secondary.text};
        color: ${(props) => props.theme.color.background};
    }
    ${MixinFocusVisible}
`;

export const SimpleTabContainer = styled.div`
    display: flex;
    gap: 10px;
    margin: 10px 0;
`;
